import { datetimeObjectFromTimestamp } from '@/helpers.js'

export default {
    // HomePage mutations
    SET_HOME_ACTIVE_CAREER (state, activeCareer) {
        state.homePageActiveCareer = activeCareer
    },
    SET_COURSES_LIST (state, courses) {
        state.coursesList = courses
    },
    SET_CURRENT_POSSIBLE_SEMESTERS (state, currentSemesters) {
        state.currentPossibleSemesters = currentSemesters
    },

    // User Credentials mutations
    AUTHENTICATE_USER (state, userToken) {
        state.userToken = userToken
    },
    CLEAR_AUTHENTICATED_USER (state) {
        state.userToken = ''
    },
    SET_USER_DATA (state, userData) {
        state.userData.id = userData.id
        state.userData.identityCard = userData.identity_card
        state.userData.displayName = userData.name.split(' ')[0] + ' ' + userData.lastname.split(' ')[0]
        state.userData.email = userData.email
        state.userData.emailSettings = userData.profile.email_settings
        // Check user role
        if (userData.administrator) {
            state.userData.role = state.userRoles.administrator
        } else if (userData.professor) {
            state.userData.role = state.userRoles.professor
        } else if (userData.student) {
            state.userData.studentId = userData.student.id
            state.userData.role = state.userRoles.student
        }
    },
    SET_USER_RELATED_SITES (state, relatedSites) {
        state.userData.relatedSites = relatedSites
    },
    SET_USER_RELATED_RECENT_SITES (state, recentSites) {
        state.userData.relatedRecentSites = recentSites
    },
    RESET_USER_DATA (state) {
        state.userData.id = null
        state.userData.identityCard = null
        state.userData.displayName = null
        state.userData.email = null
        state.userData.emailSettings = null
        state.userData.emailSettings = null
        state.userData.relatedSites = []
        state.userData.relatedRecentSites = []
        state.userData.role = null
    },
    SET_USER_EMAIL (state, newEmail) {
        state.userData.email = newEmail
    },
    SET_USER_NOTIFICATIONS (state, newEmailSettings) {
        state.userData.emailSettings = newEmailSettings
    },

    // AdminPage mutations
    SET_ADMIN_ACTIVE_CAREER (state, activeCareer) {
        state.adminPageActiveCareer = activeCareer
    },
    SET_ADMIN_SELECTED_COURSE (state, selectedCourse) {
        state.adminSelectedCourse = selectedCourse
    },
    SET_PROFESSORS_LIST (state, professors) {
        state.professorsList = professors
    },
    SET_ADMIN_SELECTED_PROFESSOR (state, selectedProfessor) {
        state.adminSelectedProfessor = selectedProfessor
    },
    SET_STUDENTS_LIST (state, students) {
        state.studentsList = students
    },
    SET_ADMIN_SELECTED_STUDENT (state, selectedStudent) {
        state.adminSelectedStudent = selectedStudent
    },

    // ////////////////////////////////////////////////////////////////
    //                        SitePage mutations                     //
    // ////////////////////////////////////////////////////////////////

    SET_SERVER_TIME (state, serverTimeString) {
        state.serverTime = datetimeObjectFromTimestamp(serverTimeString)
    },
    SET_ACTIVE_SITE (state, activeSite) {
        state.activeSite = activeSite
    },
    SET_ACTIVE_SITE_STUDENTS (state, studentsList) {
        if (studentsList.length) {
            state.activeSiteStudents = studentsList
        } else {
            state.activeSiteStudents = null
        }
    },
    SET_PERVIOUS_SEMESTERS_SITE (state, previousSemestersSites) {
        state.activeSitePreviousSemestersSites = previousSemestersSites
    },
    SET_ACTIVE_SITE_LOGS (state, logsList) {
        state.activeSiteLogs = logsList
    },
    SET_ACTIVE_SITE_ASSIGNMENTS (state, assignmentsList) {
        state.activeSiteAssignments = assignmentsList
    },
    SET_ACTIVE_SITE_FORUMS (state, forumPostsList) {
        state.activeSiteForumPosts = forumPostsList
    },
    SET_ACTIVE_SITE_NEWS_CONFIG (state, newsConfig) {
        state.activeSite.config.notices_type = newsConfig.displayTwitterFeed
        state.activeSite.config.notices_twitter = newsConfig.twitterId
    },
    SET_SINGLE_STUDENT_GRADES (state, grades) {
        state.singleStudentGrades = grades
    },
    SET_ACTIVE_SITE_GRADES (state, grades) {
        state.activeSiteGrades = grades
    },
    RESET_ACTIVE_SITE_DATA (state) {
        state.serverTime = null
        state.activeSite = null
        state.activeSiteStudents = null
        state.activeSitePreviousSemestersSites = null
        state.activeSiteAssignments = null
        state.activeSiteForumPosts = null
        state.activeSiteLogs = null
        state.singleStudentGrades = null
        state.activeSiteGrades = null
    },

    // ///////////////    SitePages CRUD mutations    /////////////////
    SET_SELECTED_CRUD_OBJECT (state, crudObject) {
        // A crud object is any object that can be created, updated or deleted in this app
        // e.g. A timetable, objectives, thematic contents, bibliographies, etc... can be crudObjects
        state.selectedCrudObject = crudObject
    },
    RESET_SELECTED_CRUD_OBJECT (state) {
        state.selectedCrudObject = null
    },
    SET_SELECTED_NEWS_OBJECT (state, newsObject) {
        state.selectedNewsObject = newsObject
    },
    RESET_SELECTED_NEWS_OBJECT (state) {
        state.selectedNewsObject = null
    },
    SET_SELECTED_FORUM_POST_OBJECT (state, forumPostObject) {
        state.selectedForumPostObject = forumPostObject
    },
    DELETE_FORUM_POST_OBJECT (state, forumPostId) {
        if (state.activeSiteForumPosts) {
            state.activeSiteForumPosts = state.activeSiteForumPosts.filter((forumPost) => {
                return forumPost.id !== forumPostId
            })
        }
    },
    SET_SELECTED_FORUM_POST_COMMENTS (state, forumPostComments) {
        state.selectedForumPostComments = forumPostComments
    },
    DELETE_FORUM_POST_COMMENT_OBJECT (state, forumPostCommentId) {
        if (state.selectedForumPostComments) {
            state.selectedForumPostComments = state.selectedForumPostComments.filter((forumPostComment) => {
                return forumPostComment.id !== forumPostCommentId
            })
        }
    },
    RESET_SELECTED_FORUM_POST_OBJECT (state) {
        state.selectedForumPostObject = null
        state.selectedForumPostComments = null
    },
    SET_ACTIVE_SITE_TEACHER_SURVEYS (state, teacherSurveyList) {
        state.activeSiteTeacherSurveys = teacherSurveyList
    },
    SET_ACTIVE_SITE_STUDENT_SURVEYS (state, studentSurveyList) {
        state.activeSiteStudentSurveys = studentSurveyList
    },
    RESET_ACTIVE_SITE_SURVEYS (state) {
        state.activeSiteStudentSurveys = null
        state.activeSiteTeacherSurveys = null
    },
    SET_SELECTED_SURVEY_OBJECT (state, wholeSurveyData) {
        state.selectedSurveyObject = wholeSurveyData
    },
    RESET_SELECTED_SURVEY_OBJECT (state) {
        state.selectedSurveyObject = null
    },
    SET_SELECTED_SURVEY_QUESTION_ID (state, surveyQuestionId) {
        state.selectedSurveyQuestionId = surveyQuestionId
    },
    RESET_SELECTED_SURVEY_QUESTION_ID (state) {
        state.selectedSurveyQuestionId = null
    },
    SET_SELECTED_ASSIGNMENT (state, assignmentObject) {
        state.selectedAssignment = assignmentObject
    },
    RESET_SELECTED_ASSIGNMENT (state) {
        state.selectedAssignment = null
    },
    SET_SELECTED_CALENDAR_DATE (state, dateString) {
        state.selectedCalendarDate = dateString
    },
    RESET_SELECTED_CALENDAR_DATE (state) {
        state.selectedCalendarDate = null
    },
    CREATE_CALENDAR_EVENT (state, eventObject) {
        state.activeSite.planifications.push(eventObject)
    },
    UPDATE_CALENDAR_EVENT (state, eventObject) {
        state.activeSite.planifications = state.activeSite.planifications.filter((event) => {
            return event.id !== eventObject.id
        })
        state.activeSite.planifications.push(eventObject)
    },
    DELETE_CALENDAR_EVENT (state, eventId) {
        state.activeSite.planifications = state.activeSite.planifications.filter((event) => {
            return event.id !== eventId
        })
    },
    INCREASE_VIDEO_CLICK_COUNT (state, videoId) {
        let targetVideo = state.activeSite.videos.filter((video) => {
            return video.id === videoId
        })
        if (targetVideo.length) {
            targetVideo[0].times_watched += 1
        }
    },
    SET_LOADING_COMPONENT (state, currentLoad) {
        state.loadingComponent = currentLoad
    }
}
